import { BG_SCHEMA, BUTTON_SCHEMA, TEXT_SCHEMA } from '../common/content'
import { commonBeforeParseMethod, commonGetIdMethod } from '../helpers'

export const MENU_OPTION = () => ({
  action: '',
  caption: 'Link',
  destination: 'Seção',
  open: false,
  style: 'text',
  'border-radius': '16',
  textColor: '#FFFFFF',
  color: '#202020',
})

export const MENU_SCHEMA = config => {
  const {id, idLayout, pageId} = commonGetIdMethod(config)

  return {
    type: 'menu',
    id: id,
    idLayout: idLayout,
    pageId: pageId,
    name: '',
    buttons: [BUTTON_SCHEMA()],
    bg: BG_SCHEMA(),
    text: TEXT_SCHEMA(),
    logo: 'https://cdn.blueticket.com.br/assets/bt-logo-azul.png',
    logo_height: 60,
    options: [MENU_OPTION()]
  }
}

export const beforeParseMenu = target => {
  commonBeforeParseMethod(target)
  if (!target.buttons) Object.assign(target, {buttons: [BUTTON_SCHEMA()]})
}

export const MENU_SECTION = config => ({
  schema: MENU_SCHEMA(config),
  beforeParse: beforeParseMenu
})
